import { Component } from '@angular/core';
import { AbstractFormControl } from '../abstract-form-control';
import { NG_VALUE_ACCESSOR, } from '@angular/forms';
import SensorPurposeEnum = SensorItemDto.PurposeEnum;
import { SensorItemDto } from '@artemis-software/wr-api';

@Component({
  standalone: false,
  selector: 'wr-sensor-purpose-select',
  templateUrl: './sensor-purpose-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SensorPurposeSelectComponent,
      multi: true,
    },
  ],
})
export class SensorPurposeSelectComponent extends AbstractFormControl<SensorPurposeEnum> {
  readonly values = Object.values(SensorPurposeEnum);

  placeholder = 'Verwendung auswählen';
}
